<template>
    <div>
      <!--<countdown class="countdown"/>-->
      <div class="city-name">{{cityData.name}}</div>
      <div>
        <div class="city-date">{{cityData.dateString}}</div>
        <div class="city-address">{{cityData.address1}}</div>
        <div class="city-address">{{cityData.address2}}</div>
        <div class="city-address">{{cityData.address3}}</div>
      </div>
      <spacing value="1.5rem"/>
      <headline value=">> Score"/>
      <score-bar-h :city="cityData" hide-label="true" :max-score="maxScore"/>
      <spacing value="1.5rem"/>
    </div>
</template>

<script>
    import Countdown from "./Countdown";
    import Backend from '@/BackendProxy';
    import ScoreBarH from './ScoreBarH';
    import Headline from "./Headline";
    import Spacing from "./Spacing";
    import detect from 'detect-browser';

    export default {
      components: {
        Spacing,
        Headline,
        ScoreBarH,
        Countdown},
      name: "city-header",
      props:['city'],
      data() {
        return {
          cityData: Backend.instance.getCityData(this.city),
          maxScore: Backend.instance.maxScore
        }
      }
    }
</script>

<style lang="scss" scoped>
  .countdown {
    margin-top: -100px;
    @media screen and (max-width: 900px) {
      margin-top: -50px;
    }
  }
  .city-name {
    font-size: 4rem;
    font-weight: 400;
    margin-bottom: -0.5rem;
  }
  .city-date {
    font-size: 2rem;
    margin-bottom: 0.3rem;
  }
  .city-address {
    font-size: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/blocks/CityHeader.vue